//import 'reflect-metadata';

import "core-js/actual/array/flat";
import "core-js/actual/array/flat-map";
import "core-js/actual/object/from-entries";

import { LogGroup, Scale, SetStyles } from "../multigame/MyHelpers";

import { AudioManager } from "../multigame/AudioManager";
import { SharedVideoContainer } from "../multigame/Context/SharedVideoContext";
import { ISystemContext, SystemContext } from "../multigame/Context/SystemContext";
import { ResourceIdentifier } from "../multigame/ResourceManager/ResourceIdentifier";
import { ResourceManager } from "../multigame/ResourceManager/ResourceManager";
import { Settings } from "../multigame/Settings";
;

import { CSSPlugin, gsap } from "gsap";
import { GetOrientation } from "../multigame/FitScreen";
// import { service } from "../multigame/services";


import { BackendSettingsService } from "../services/BackendSettingsService";
// import { Logger } from "tslog";
import * as PIXI from 'pixi.js';
import { SharedTransitionContainer } from '../multigame/Context/SharedTransitionContext';
import { moneyFormatter } from '../multigame/MoneyFormatter';
import { service } from "../multigame/services";
import { IsBackendConnectionLost } from "../multigame/ConnectionLostModal";
import { FountainPIXI } from '../multigame/slot/FountainAnimationPIXI';
import { SpeedManager } from '../multigame/SpeedManager';
import { IOManagerService } from '../services/IOManagerService';
import { TranslationService } from '../services/TranslationService';
import { MockUpPixiApp_Responsive } from './MockUpPixiApp_Responsive';
import { CreateSinglegameConnection, SinglegameApi } from "./singlegame_api_extended";
import { Singlegame_PIXIAPP } from './Singlegame_PIXIAPP';
import { serviceProvider } from './SinglegameServiceMap';
import { AudioService } from "../services/AudioService";
import { GameEngineResponsive } from "../multigame/engine/GameEngineResponsive";
import { BootHide, BootSetProgress } from "./boot-progress";
import { LoadFrontendLaunchSettings } from "./FrontendLaunchSettings";

export let singleApi: SinglegameApi = null;

//let audio: AudioManager;
//let speedManager: SpeedManager;

// register dependency injection
function registerDI()
{
	
	//container.register<IMoneyFormatterService>("IMoneyFormatterService", {useValue: moneyFormatter});
	serviceProvider.RegisterValue("MoneyFormatter", moneyFormatter);

	//console.log(`registerDI`, `SinglegameConnection`);
	//container.register<HubConnection>("SinglegameConnection", {useValue: CreateSinglegameConnection()});
	serviceProvider.RegisterValue("HubConnection", CreateSinglegameConnection());
		
	//container.register<SinglegameApi>("SinglegameApi", {useClass: SinglegameApi});
	serviceProvider.RegisterFactory("SinglegameApi", ["HubConnection"], SinglegameApi);

	//container.register<TranslationService>("TranslationService", {useValue: new TranslationService});
	serviceProvider.RegisterValue("TranslationService", new TranslationService());


	//container.register<IOManagerService>("IOManagerService", {useValue: new IOManagerService()});
	serviceProvider.RegisterValue("IOManagerService", new IOManagerService());

	//container.register<FountainPIXI>("FountainPIXI", {useClass: FountainPIXI});
	serviceProvider.RegisterFactory("FountainPIXI", [], () => new FountainPIXI(new PIXI.Rectangle(0, 0, Scale.W(960), Scale.H(540)), new PIXI.Rectangle(0, 0, Scale.W(120), Scale.H(120)), 0.6));

	// container.register<Logger>("Logger", Logger);
	//console.log(`registerDI`, `ResourceIdentifier`);
	//const resid: ResourceIdentifier = new ResourceIdentifier(ResourceIdentifier.Shared, "Singlegame");
	//container.register<ResourceIdentifier>(`ResourceIdentifier`, {useValue: resid});
	serviceProvider.RegisterValue("ResourceIdentifier", new ResourceIdentifier(ResourceIdentifier.Shared, "Singlegame"));
	serviceProvider.RegisterValue("LogGroup", new LogGroup("Singlegame"));

	//console.log(`registerDI`, `AudioManager`);
	//audio = new AudioService(new ResourceIdentifier(ResourceIdentifier.Shared, "Audio"));
	serviceProvider.RegisterFactory("AudioManager", ["ResourceIdentifier"], AudioService);

	//console.log(`registerDI`, `SpeedManager`);
	//speedManager = new SpeedManager()
	serviceProvider.RegisterFactory("SpeedManager", [], SpeedManager); 

	//console.log(`registerDI`, `SharedVideoContainer`);
	//let sharedVideoContainer = new SharedVideoContainer(new ResourceIdentifier(ResourceIdentifier.Shared, "SharedVideoGame"), new LogGroup("SharedVideoGame"));

	//serviceProvider.RegisterValue("LogGroup", new LogGroup("SharedVideoGame"));

	serviceProvider.RegisterFactory("SharedVideoContainer", ["ResourceIdentifier", "LogGroup"], SharedVideoContainer);

	//console.log(`registerDI`, `SharedTransitionContainer`);
	//let sharedTransitionContainer = new SharedTransitionContainer(new ResourceIdentifier(ResourceIdentifier.Shared, "SharedTransitionContainer"), new LogGroup("SharedTransitionContainer"));
	serviceProvider.RegisterFactory("SharedTransitionContainer", ["ResourceIdentifier", "LogGroup"], SharedTransitionContainer);

	// console.log(`0registerDI`, `FountainPIXI`);
	// let fountainPIXI = new FountainPIXI(new PIXI.Rectangle(0, 0, Scale.W(960), Scale.H(540)), new PIXI.Rectangle(0, 0, Scale.W(120), Scale.H(120)), 0.6);

	// console.log(`registerDI`, `ResourceManager`);
	// let resourceManager: ResourceManager = new ResourceManager(new LogGroup("ResourceManager"));
	// resourceManager.AddReadyToLoadCallback(() => {
	// 	const audio = serviceProvider.Resolve("AudioManager");
	// 	audio.GetResources().forEach((t) => resourceManager.Add(t))
	// });


	// let globalSystemContext: ISystemContext = new SystemContext(
	// 	new ResourceIdentifier(ResourceIdentifier.Shared, "SystemContext"), new LogGroup("SystemContext"),
	// 	resourceManager,
	// 	sharedVideoContainer,
	// 	sharedTransitionContainer
	// );

	//container.register<ResourceManager>("ResourceManager", {useValue: resourceManager});
	serviceProvider.RegisterFactory("ResourceManager", ["LogGroup"], ResourceManager);

	//console.log(`registerDI`, `AudioManager`);
	//container.register<AudioManager>("AudioManager", {useValue: audio});
	//serviceProvider.RegisterValue("AudioManager", audio);

	//console.log(`registerDI`, `SpeedManager`);
	//container.register<SpeedManager>("SpeedManager", {useValue: speedManager});
	//serviceProvider.RegisterValue("SpeedManager", speedManager);

	//console.log(`registerDI`, `SharedVideoContainer`);
	//container.register<SharedVideoContainer>("SharedVideoContainer", {useValue: sharedVideoContainer});
	//serviceProvider.RegisterValue("SharedVideoContainer", sharedVideoContainer);
	
	//console.log(`registerDI`, `SharedTransitionContainer`);
	//container.register<SharedTransitionContainer>("SharedVideoContainer", {useValue: sharedTransitionContainer});
	//serviceProvider.RegisterValue("SharedTransitionContainer", sharedTransitionContainer);

	//console.log(`registerDI`, `ISystemContext`);
	//container.register<ISystemContext>("ISystemContext", {useValue: globalSystemContext});
	serviceProvider.RegisterFactory("SystemContext", ["ResourceIdentifier", "LogGroup", "ResourceManager", "SharedVideoContainer", "SharedTransitionContainer"], SystemContext);

	//console.log(`registerDI`, `GameViewAppPixiResponsive`);
	//container.register<GameViewAppPixiResponsive>("GameViewAppPixiResponsive", GameViewAppPixiResponsive);
	serviceProvider.RegisterFactory("GameEngineResponsive", ["ResourceIdentifier", "SystemContext"], GameEngineResponsive);
		//  (resid, ctx) => new GameViewAppPixiResponsive(resid, ctx));

	//console.log(`registerDI`, `IBackendSettingsService`);
	//container.register("IBackendSettingsService", {useClass: BackendSettingsService});
	serviceProvider.RegisterFactory("BackendSettings", [], BackendSettingsService);

	//console.log(`registerDI`, `Singlegame_PIXIApp`);
	//container.register<Singlegame_PIXIAPP>("Singlegame_PIXIApp", Singlegame_PIXIAPP);
	serviceProvider.RegisterFactory(
		"Singlegame", 
		["SystemContext", "ResourceManager", "AudioManager", "HubConnection", "SinglegameApi", "BackendSettings", "TranslationService", "MoneyFormatter", "SpeedManager", "FountainPIXI", "GameEngineResponsive", "SharedVideoContainer"], 
		Singlegame_PIXIAPP
	);

	//console.log(`registerDI`, `Singlegame_PIXIApp2`);
	//container.register<Singlegame_PIXIAPP2>("Singlegame_PIXIApp2", Singlegame_PIXIAPP2);

	//console.log(`registerDI`, `FountainPIXI`);
	//container.register<FountainPIXI>("FountainPIXI", {useValue: fountainPIXI});
	//serviceProvider.RegisterValue("FountainPIXI", fountainPIXI);

	serviceProvider.Build();

	const resourceManager = serviceProvider.Resolve("ResourceManager");
	resourceManager.AddReadyToLoadCallback(() => {
		const audio = serviceProvider.Resolve("AudioManager");
		audio.GetResources().forEach((t) => resourceManager.Add(t))
	});

	console.log(`registerDI`, `Backfilling services`);
	service.iomanager = serviceProvider.Resolve("IOManagerService");

	console.log(`registerDI`, `Done`);
}




let showResponsiveMockUp: boolean = false;
//debug.InvalidateCanvas(null);
async function createResponsiveMockup()
{
	// let gameDIV = document.createElement('div');
	// gameDIV.setAttribute('class', 'game');
	// Object.assign(gameDIV.style, ResponsiveParams);

	new MockUpPixiApp_Responsive();

	// gameDIV.appendChild(MockUpApp.GetMockUpApp().view);

	document.body.style.margin = "0px";
	document.body.style.overflow = "hidden";
	document.body.style.width = "100%"
	document.body.style.height = "100%"

	// document.body.appendChild(gameDIV);
	
	// MockUpApp.resize();

	// window.addEventListener("resize", () => {
	// 	MockUpApp.resize();
	// });
}



async function startSinglegame() {

	if (showResponsiveMockUp)
	{
		await createResponsiveMockup();
		return;
	}

	// Yield so the boot loader (0%) can paint before heavy init.
	BootSetProgress(3);
	await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
    
	// localStorage.clear();

    // disable context menu
	document.body.addEventListener("contextmenu", (ev) => false);

	BootSetProgress(5);
	// language + logo/branding from FrontendLaunchSettings.json
	await LoadFrontendLaunchSettings();
	BootSetProgress(6);
	registerDI();
	BootSetProgress(8);
	await InitRenderScreenShot();
	BootSetProgress(10);
	//let multigames: IMultigame[] = [];
	
	// bootstrap
	// let superMultigame: Multigame = null;
	// let superMultigameSecond: Multigame2 = null;
	// let superMultigameThird: Multigame3 = null;
	// let superMultigameMiniScreen = null;

	//let audio: AudioManager = null;
	//let resid: ResourceIdentifier =null;
	let logGroup: string = "STARTUP";

	// reset disaply
	SetStyles(document.documentElement, {
		width: "100%",
		height: "100%",
		margin: "0px",
		padding: "0px",
	});

	SetStyles(document.body, {
		width: "100%",
		height: "100%",
		margin: "0px",
		padding: "0px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden",
	});

    // set default font before loading others
    let defFontStyle: HTMLElement = document.createElement("style");
    defFontStyle.innerHTML = "html {font-family: 'NotoSansDisplay-Regular',sans-serif}";
    document.querySelector("head").appendChild(defFontStyle);

	let superScreenWidth = Settings.ScreenWidth;
	let superScreenHeight = Settings.ScreenHeight * Settings.Screens;
	let screens = Settings.Screens;


	// if( Settings.VirtualBotoneraType == VirtualBotoneraType.BigButtons)
	// {
	// 	multigames.push(new MuiltigameMiniScreen(globalSystemContext, resourceManager, audio));
	// 	// panel is one more screen
	// 	screens += 1;

	// 	// make sure superscreen height is extended
	// 	superScreenHeight += Settings.bottoneraFakeSize.height;
	// 	superScreenWidth = Math.max(Settings.ScreenWidth, Settings.bottoneraFakeSize.width);
	// }

	
	//new Singlegame(globalSystemContext, resourceManager, audio)
	let resourceManager = serviceProvider.Resolve("ResourceManager");
	resourceManager.AddLoadFinishedCallback( async (): Promise<void> =>
	{ 
		window.addEventListener("resize", () => resize());
		window.addEventListener("orientationchange", () => resize());
		await singlegame.LoadFinishedSuccess();
	});

	async function resize()
	{
		const w = window.innerWidth;
		const h = window.innerHeight;
	
		const orientation = GetOrientation();
		// singles.forEach(s => s.multigame.OnResize(w, h, orientation));
		await singlegame.OnResize(orientation);
	}

	singleApi = serviceProvider.Resolve("SinglegameApi");
	let singlegame = serviceProvider.Resolve("Singlegame");

	// let singles = await MultipleSingles();
	
	resourceManager.AddLoadProgressCallback((progress:number) => 
	{
		singlegame.LoadProgress(progress);
		// singles.forEach(s => s.multigame.LoadProgress(progress));
	});
	// Hand off from instant HTML boot loader to in-game loading UI.
	singlegame.LoadProgress(0);
	BootHide();
	//multigames.push(singlegame);

	// if(Settings.Screens == 2)
	// {
	// 	multigames.push(new Multigame_2Screen(globalSystemContext, resourceManager, audio));
	// 	multigames.push(new Multigame2_2Screen(globalSystemContext, resourceManager, audio));
	// }

	// if(Settings.Screens==3)
	// {
	// 	multigames.push(new Multigame(globalSystemContext, resourceManager, audio));
	// 	multigames.push(new Multigame2(globalSystemContext, resourceManager, audio));
	// 	multigames.push(new Multigame3(globalSystemContext, resourceManager));
	// }

	// on button pressed
	{
	}

	// if (Settings.VirtualBotoneraType == VirtualBotoneraType.BigButtons) {
	// 	let multigame: Multigame = multigames[1] as Multigame;
	// 	let mini: MuiltigameMiniScreen = multigames[0] as MuiltigameMiniScreen
		
	// 	//callbacks
	// 	//mini.OnButtonChanged = (data , press) => multigame.OnButtonChanged(data ,press );
	// 	multigame.MultigameUpdateDenom = (Bets: SlotGameBet[], denom: number) => mini.UpdateBets(Bets, denom);
	// 	multigame.MultigameGameStateChanged = (state: GameState) => mini.UpdateState(state);

	// 	multigame.CallAttendandCallback = () => mini.CallAttendant();
	// 	multigame.CancelCallAttendandCallback = () => mini.CancelCallAttendant();
	// 	multigame.OnBetSelectCallback = (selectedBet) =>{ mini.OnBetSelectCallback(selectedBet)};
	// }

	service.iomanager = serviceProvider.Resolve("IOManagerService");
	service.iomanager.AddButonChangeHandler('SinglegameStartup',(button, pressed) => {
			if (IsBackendConnectionLost()) {
				return;
			}
			// singles.forEach(s => s.multigame.OnButtonChanged(button, pressed));
			singlegame.OnButtonChanged(button, pressed);
		});

	// let superscreen: HTMLElement = CreateElement("div", {
	// 	classes: ["superscreen", "screen"],
	// 	style: {
	// 		position: "relative",
	// 		width:"100%",
	// 		height: "100%",
	// 	}
	// });

	// append multigames from top to bottom
	// superscreen.appendChild(singlegame.BackgroundView());

	// document.body.appendChild(singlegame.BackgroundView());

	


	// document.body.innerHTML = "";
	// document.body.appendChild(superscreen);

	//FitScreen(GetFitType());



    // if (Settings.OnlineControls)
    // {
    //     let enterFullscreenIcon: string = `
    //     <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    //         viewBox="0 0 384.97 384.97" style="enable-background:new 0 0 384.97 384.97;" xml:space="preserve">
    //         <g>
    //             <g id="Fullscreen">
    //                 <path d="M384.97,12.03c0-6.713-5.317-12.03-12.03-12.03H264.847c-6.833,0-11.922,5.39-11.934,12.223
    //                     c0,6.821,5.101,11.838,11.934,11.838h96.062l-0.193,96.519c0,6.833,5.197,12.03,12.03,12.03c6.833-0.012,12.03-5.197,12.03-12.03
    //                     l0.193-108.369c0-0.036-0.012-0.06-0.012-0.084C384.958,12.09,384.97,12.066,384.97,12.03z"/>
    //                 <path d="M120.496,0H12.403c-0.036,0-0.06,0.012-0.096,0.012C12.283,0.012,12.247,0,12.223,0C5.51,0,0.192,5.317,0.192,12.03
    //                     L0,120.399c0,6.833,5.39,11.934,12.223,11.934c6.821,0,11.838-5.101,11.838-11.934l0.192-96.339h96.242
    //                     c6.833,0,12.03-5.197,12.03-12.03C132.514,5.197,127.317,0,120.496,0z"/>
    //                 <path d="M120.123,360.909H24.061v-96.242c0-6.833-5.197-12.03-12.03-12.03S0,257.833,0,264.667v108.092
    //                     c0,0.036,0.012,0.06,0.012,0.084c0,0.036-0.012,0.06-0.012,0.096c0,6.713,5.317,12.03,12.03,12.03h108.092
    //                     c6.833,0,11.922-5.39,11.934-12.223C132.057,365.926,126.956,360.909,120.123,360.909z"/>
    //                 <path d="M372.747,252.913c-6.833,0-11.85,5.101-11.838,11.934v96.062h-96.242c-6.833,0-12.03,5.197-12.03,12.03
    //                     s5.197,12.03,12.03,12.03h108.092c0.036,0,0.06-0.012,0.084-0.012c0.036-0.012,0.06,0.012,0.096,0.012
    //                     c6.713,0,12.03-5.317,12.03-12.03V264.847C384.97,258.014,379.58,252.913,372.747,252.913z"/>
    //             </g>
    //         </g>
    //     </svg>
    //     `;

    //     let exitFullscreenIcon: string = `
    //     <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    //     viewBox="0 0 385.331 385.331" style="enable-background:new 0 0 385.331 385.331;" xml:space="preserve">
    //         <g>
    //             <g id="Fullscreen_Exit">
    //                 <path d="M264.943,156.665h108.273c6.833,0,11.934-5.39,11.934-12.211c0-6.833-5.101-11.85-11.934-11.838h-96.242V36.181
    //                     c0-6.833-5.197-12.03-12.03-12.03s-12.03,5.197-12.03,12.03v108.273c0,0.036,0.012,0.06,0.012,0.084
    //                     c0,0.036-0.012,0.06-0.012,0.096C252.913,151.347,258.23,156.677,264.943,156.665z"/>
    //                 <path d="M120.291,24.247c-6.821,0-11.838,5.113-11.838,11.934v96.242H12.03c-6.833,0-12.03,5.197-12.03,12.03
    //                     c0,6.833,5.197,12.03,12.03,12.03h108.273c0.036,0,0.06-0.012,0.084-0.012c0.036,0,0.06,0.012,0.096,0.012
    //                     c6.713,0,12.03-5.317,12.03-12.03V36.181C132.514,29.36,127.124,24.259,120.291,24.247z"/>
    //                 <path d="M120.387,228.666H12.115c-6.833,0.012-11.934,5.39-11.934,12.223c0,6.833,5.101,11.85,11.934,11.838h96.242v96.423
    //                     c0,6.833,5.197,12.03,12.03,12.03c6.833,0,12.03-5.197,12.03-12.03V240.877c0-0.036-0.012-0.06-0.012-0.084
    //                     c0-0.036,0.012-0.06,0.012-0.096C132.418,233.983,127.1,228.666,120.387,228.666z"/>
    //                 <path d="M373.3,228.666H265.028c-0.036,0-0.06,0.012-0.084,0.012c-0.036,0-0.06-0.012-0.096-0.012
    //                     c-6.713,0-12.03,5.317-12.03,12.03v108.273c0,6.833,5.39,11.922,12.223,11.934c6.821,0.012,11.838-5.101,11.838-11.922v-96.242
    //                     H373.3c6.833,0,12.03-5.197,12.03-12.03S380.134,228.678,373.3,228.666z"/>
    //             </g>
    //         </g>
    //     </svg>
    //     `;
	// 	let isFullscreen: boolean = false;
	// 	let containerfullscreen = CreateElement("div", {
	// 		classes: ["containerfullscreen"],
	// 		parentToAppend: superscreen,
	// 		style: {
	// 			top: "0px",
	// 			//left: "10px",
	// 			position: "relative",
	// 			width: "50px",
	// 			height: "50px",
	// 			background: "rgba(255, 255, 255, 0.5)",
	// 			zIndex: ZIndex.FullScreen.toString(),
	// 			borderRadius: "10px",
	// 			padding: "10px",
	// 			//border: "1px solid red"
	// 		},
	// 	});
	// 	let fullscreen = CreateElement("div", {
	// 		classes: ["fullscreen"],
	// 		innerHTML: enterFullscreenIcon,
	// 		parentToAppend: containerfullscreen,
	// 		style: {
	// 			//top: "10px",
	// 			//left: "10px",
	// 			//position: "absolute",
	// 			//width: "50px",
	// 			//height: "50px",
	// 			//background: "rgba(255, 255, 255, 0.5)",
	// 			//zIndex: ZIndex.FullScreen.toString(),
	// 			borderRadius: "10px",
	// 			//padding: "10px"
	// 		},
	// 		mousedown: () => {
	// 			console.log("Toggle fullscreen");

	// 			setTimeout(() => {
	// 				if (!document.fullscreenElement) {
	// 					document.body.requestFullscreen()
	// 						.then(() => {
	// 							fullscreen.innerHTML = exitFullscreenIcon;
	// 						})
	// 						.catch(err => {
	// 							alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
	// 						});
	// 				} else {
	// 					document.exitFullscreen()
	// 						.then(() => {
	// 							fullscreen.innerHTML = enterFullscreenIcon;
	// 						});
	// 				}
	// 			}, 100);
	// 		}
	// 	});

	// }

	// singles.forEach(s => s.multigame.ViewReady());
	singlegame.ViewReady();

	//setInterval(() => multigame.Update(), 1000.0 / 20);
	gsap.ticker.fps(60);
	//TweenLite.ticker.fps(60);
	CSSPlugin.defaultTransformPerspective = 800;

	gsap.ticker.add(() => {
		// singles.forEach(s => s.multigame.Update());
		singlegame.Update();
	});

	// const resize = () => {
	// 	const w = window.innerWidth;
	// 	const h = window.innerHeight;

	// 	const orientation = GetOrientation();

	// 	singlegame.OnResize(w, h, orientation);
	// };

	// // GlobalLoadCoordinator.Instance.AddOnGlobalFinished(() => {
	// // 	window.addEventListener("resize", resize);
	// // 	window.addEventListener("orientationchange", resize);

	// 	resize();
	// // });
}

// Dynamic import from bootstrap may run after window "load" already fired.
if (document.readyState === "complete" || document.readyState === "interactive") {
	void startSinglegame();
} else {
	window.addEventListener("load", () => { void startSinglegame(); });
}

// export async function MultipleSingles(): Promise<NamedMultigame[]>
// {
// 	let singleGames: NamedMultigame[] = [];

// 	singleGames.push({
// 		type: MultigameType.Singlegame,
// 		multigame: container.resolve<Singlegame_PIXIAPP>("Singlegame_PIXIApp")
// 	});

// 	singleGames.push({
// 		type: MultigameType.Singlegame2,
// 		multigame: container.resolve<Singlegame_PIXIAPP2>("Singlegame_PIXIApp2")
// 	});

// 	return singleGames;
	
// }


// prevent pinch zoom
window.addEventListener("touchstart", (ev: TouchEvent) => {
	if(ev.touches.length > 1) {
		ev.preventDefault();
	}
}, {passive: false});

// prevent text select
window.addEventListener("selectstart", (ev: Event) => {
	ev.preventDefault();
});


export function InitRenderScreenShot(){
    if (globalThis.renderSymbol == undefined) {
        let canvas = document.createElement('canvas');
        canvas.id = `ScreenShootFeatureCanvas`;
        canvas.width = 1920
        canvas.height = 1080,


     globalThis.renderSymbol = new PIXI.Renderer({
            width: 1920,
            height: 1080,
            resolution: 1,  // asegúrate que esto es consistente con tu app
            antialias: true,
            autoDensity: true,
            powerPreference: "high-performance",
            view : canvas           
        });
    }
    else return
}